// Global Types
import type {
  $WithRouter,
} from '@vroskus/library-navigation';
import type {
  $Model,
} from 'common.data';
import type {
  $Translate,
} from 'common.language';

// Global Enums
import {
  adminPages,
  adminSections,
} from 'common.enums';

// Global Components
import * as React from 'react';
import {
  Button,
  Card,
} from 'reactstrap';
import {
  SectionHeader,
} from '@vroskus/library-components';

// Helpers
import {
  defaultGetData,
} from '../../../helpers';

// Components
import Page from '../../layout/Page';
import ChampionshipAdminsSection from '../../sections/ChampionshipPageSections/ChampionshipAdminsSection';
import ChampionshipSettingsSection from '../../sections/ChampionshipPageSections/ChampionshipSettingsSection';
import ChampionshipDescriptionSection from '../../sections/ChampionshipPageSections/ChampionshipDescriptionSection';
import ChampionshipRegattasSection from '../../sections/ChampionshipPageSections/ChampionshipRegattasSection';
import ChampionshipDocumentsSection from '../../sections/ChampionshipPageSections/ChampionshipDocumentsSection';
import ChampionshipResultTablesSection from '../../sections/ChampionshipPageSections/ChampionshipResultTablesSection';
import ChampionshipSponsorsSection from '../../sections/ChampionshipPageSections/ChmapionshipSponsorsSection';

// Services
import Services from '../../../services';

// Types
import type {
  $RedirectAction,
} from '../../../redux/modules/main/actions';

export type $OwnProps = $Translate & $WithRouter;

export type $StateProps = Record<string, never>;

export type $DispatchProps = {
  redirect: $RedirectAction;
};

type $Props = $DispatchProps & $OwnProps & $StateProps;

type $State = {
  item: $Model<'Championship'> | null;
};

const pageId = adminPages.championshipPage;

class ChampionshipPageView extends React.Component<$Props, $State> {
  constructor(props: $Props) {
    super(props);

    this.state = {
      item: null,
    };
  }

  componentDidMount(): void {
    this.getData();
    this.setupSocket();
  }

  setupSocket(): void {
    Services.Socket.on({
      action: (data) => {
        const {
          params,
        } = this.props;
        const {
          ChampionshipId,
        } = params;

        if (data.ChampionshipId === ChampionshipId && data.modelName === 'Championship') {
          this.getData();
        }
      },
      type: Services.Socket.type.modelChangedEvent,
    });
  }

  setStateAsync(state: Partial<$State>): Promise<void> {
    return new Promise((resolve) => {
      this.setState(
        (pervState: $State) => ({
          ...pervState,
          ...state,
        }),
        resolve,
      );
    });
  }

  async getData(): Promise<void> {
    const {
      params,
    } = this.props;

    const {
      ChampionshipId,
    } = params;

    await defaultGetData({
      action: async () => {
        if (ChampionshipId) {
          const item = await Services.Api.getOneChampionship({
            id: ChampionshipId,
          });

          await this.setStateAsync({
            item,
          });
        }
      },
    });
  }

  renderHeader() {
    const {
      redirect,
      t,
    } = this.props;
    const {
      item,
    } = this.state;

    return (
      <Card id={adminSections[pageId].header}>
        <SectionHeader
          description={item !== null ? item.Name : ''}
          title={t('Championship')}
          titleButton={(
            <Button
              className={'mr-2'}
              color={'secondary'}
              id={'redirect-championships-page-button'}
              onClick={() => redirect({
                pathname: '/championships',
              })}
              size={'sm'}
            >
              <em className={'fa icon-arrow-left'} />
            </Button>
          )}
        />
      </Card>
    );
  }

  renderContent() {
    const {
      item,
    } = this.state;

    return (item !== null ? (
      <>
        <ChampionshipSettingsSection
          id={adminSections[pageId].settings}
          item={item}
        />
        <ChampionshipDescriptionSection
          id={adminSections[pageId].description}
          item={item}
        />
        <ChampionshipRegattasSection
          id={adminSections[pageId].regattas}
          item={item}
        />
        <ChampionshipDocumentsSection
          id={adminSections[pageId].documents}
          item={item}
        />
        <ChampionshipResultTablesSection
          id={adminSections[pageId].results}
          item={item}
        />
        <ChampionshipSponsorsSection
          id={adminSections[pageId].sponsors}
          item={item}
        />
        <ChampionshipAdminsSection
          id={adminSections[pageId].admins}
          item={item}
        />
      </>
    ) : null);
  }

  render() {
    return (
      <Page id={pageId}>
        <>
          {this.renderHeader()}
          {this.renderContent()}
        </>
      </Page>
    );
  }
}

export default ChampionshipPageView;
